import { createRouter, createWebHistory } from 'vue-router'

import Index from '../components/Index.vue';

const router = createRouter({
  history: createWebHistory(),
  mode: 'history',
  base: '/',
  routes: [
    { path: '/konfigurator', name: 'konfigurator', component: Index },
    { path: '/hausnotruf', name: 'hausnotruf', component: Index },
    { path: '/', name: 'default', component: Index }, // For local setup
    { path: '/vue-3/demo/voucher-search', name: 'demo', component: Index }, // For demo setup
    { path: '/vue-3/voucher-search', name: 'live', component: Index } // For live setup
  ]
})

export default router
